import { Component, Input, TemplateRef } from '@angular/core';
import {
  ButtonSize,
  ButtonType,
  ElementType
} from '../../../types/button.types';
import { PositionType } from '../../../types/common.types';

@Component({
  selector: 'idp-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss']
})
export class PopoverComponent {
  @Input() buttonLabel = '';
  @Input() buttonType: ButtonType = 'primary';
  @Input() buttonsize: ButtonSize = 'medium';
  @Input() content = '';
  @Input() position: PositionType = 'bottom';
  @Input() elementType: ElementType = 'button';
  @Input() showOnClick = true; // to display tooltip on click
  @Input() showOnHover = false; // to display tooltip on mouse enter
  @Input()
  hostElement!: TemplateRef<HTMLElement>; // this will be the hostelemt on which tooltip/popover will be displayed

  // this will be the hostelemt on which tooltip/popover will be displayed.
  @Input() tooltipRole = false;
}
